module.exports = __webpack_public_path__ + "img/reading.13f81738.jpeg";